module.exports = __webpack_public_path__ + "media/misc/hr-base-95f20007.png";